import React, { Component } from "react";
import Proptypes from "prop-types";
import { connect } from "react-redux";
import { Form, FormGroup, Button, Label, Row, Col, CardBody, CardFooter } from "reactstrap";
import {
    renderField,
    required,
    renderTextArea,
} from "../../../../utils/formValidations.js";
import { Field, reduxForm } from "redux-form";
import { withRouter } from "react-router-dom";


class OciDnsProviderFormTemplate extends Component {

    constructor(props) {
        super(props);
        this.state = {
            currentProvider: {},
        };
        this.submitApi = this.submitApi.bind(this);
        this.cancelButton = this.cancelButton.bind(this);

    }

    componentDidMount() {
        if (this.props.current_provider) {
            this.props.initialize({
                dns_provider_config_name: this.props.current_provider.dns_provider_config_name,
                dns_provider_name: this.props.current_provider.dns_provider_name,
                oci_fingerprint: this.props.current_provider.oci_fingerprint,
                oci_tenancy_ocid: this.props.current_provider.oci_tenancy_ocid,
                oci_region: this.props.current_provider.oci_region,
                oci_compartment_ocid: this.props.current_provider.oci_compartment_ocid,
                oci_user_ocid: this.props.current_provider.oci_user_ocid,
                oci_private_key: this.props.current_provider.oci_private_key,
            });
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.current_provider && this.props.current_provider !== nextProps.current_provider) {
            this.props.initialize({
                dns_provider_config_name: nextProps.current_provider.dns_provider_config_name,
                dns_provider_name: nextProps.current_provider.dns_provider_name,
                oci_fingerprint: nextProps.current_provider.oci_fingerprint,
                oci_tenancy_ocid: nextProps.current_provider.oci_tenancy_ocid,
                oci_region: nextProps.current_provider.oci_region,
                oci_compartment_ocid: nextProps.current_provider.oci_compartment_ocid,
                oci_user_ocid: nextProps.current_provider.oci_user_ocid,
                oci_private_key: nextProps.current_provider.oci_private_key,
            });
        }
    }


    cancelButton() {
        this.props.cancel_button(userData)
    }


    submitApi(userData) {
        userData.dns_provider_name = "oci"
        this.props.submit_api(userData)

    }

    render() {
        const { handleSubmit } = this.props;

        return (
            <Form onSubmit={handleSubmit(this.submitApi)}>
                <CardBody>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="dns_provider_config_name" className="requiredasterisk">Name </Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="dns_provider_config_name"
                                    id="dns_provider_config_name"
                                    component={renderField}
                                    validate={required}
                                    placeholder="Example Oci Config"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="oci_fingerprint" className="requiredasterisk">Fingerprint</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="oci_fingerprint"
                                    id="oci_fingerprint"
                                    component={renderField}
                                    validate={required}
                                    placeholder="00:00:00:00:00:00:00:00:00:00:00:00:00:00:00:00"
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="oci_tenancy_ocid" className="requiredasterisk">Tenancy OCID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="oci_tenancy_ocid"
                                    id="oci_tenancy_ocid"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="oci_region" className="requiredasterisk">Region</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="oci_region"
                                    id="oci_region"
                                    component={renderField}
                                    validate={required}
                                    placeholder="us-ashburn-2"
                                />
                            </Col>
                        </Row>
                    </FormGroup>

                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="oci_compartment_ocid" className="requiredasterisk">Compartment OCID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="oci_compartment_ocid"
                                    id="oci_compartment_ocid"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="oci_user_ocid" className="requiredasterisk">User OCID</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="oci_user_ocid"
                                    id="oci_user_ocid"
                                    component={renderField}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                    <FormGroup>
                        <Row>
                            <Col>
                                <Label htmlFor="oci_private_key" className="requiredasterisk">Private Key</Label>
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Field type="text"
                                    name="oci_private_key"
                                    id="oci_private_key"
                                    placeholder="-----BEGIN PRIVATE KEY-----&#10;...&#10;-----END PRIVATE KEY-----"
                                    component={renderTextArea}
                                    validate={required}
                                />
                            </Col>
                        </Row>
                    </FormGroup>
                </CardBody>
                <CardFooter>
                    <FormGroup className="form-actions">
                        <Button type="button" size="sm"
                            className="cancel-button"
                            color="basic" onClick={() => this.props.cancel_button()}>{ this.props.wizard ? 'Previous' : 'Cancel'}</Button>
                        <Button type="submit"
                            className="submit-button"
                            size="sm" color="primary">{ this.props.wizard ? 'Finish' : 'Submit'}</Button>
                    </FormGroup>
                </CardFooter>
            </Form>
        );
    }
}


OciDnsProviderFormTemplate.propTypes = {
    current_provider: Proptypes.object,
    submit_api: Proptypes.func.isRequired,
    handleSubmit: Proptypes.func,
    cancel_button: Proptypes.func,
};


let OciDnsProviderFormWithRouter = withRouter(OciDnsProviderFormTemplate);

let OciDnsProviderForm = connect(state => {

    return {
        dns_provider_configs: state.dns_provider.dns_provider_configs,
    }
},

    dispatch =>
    ({

    }))(OciDnsProviderFormWithRouter);

export default reduxForm({
    form: "DnsProviderForm",
})(OciDnsProviderForm);
